// src/utils/formato.js
// Formateo de números y fechas en un solo lugar, para que todas las pantallas
// muestren los importes igual.

const formatterMoneda = new Intl.NumberFormat('es-AR', {
  style: 'currency',
  currency: 'ARS',
  maximumFractionDigits: 0
});

const formatterNumero = new Intl.NumberFormat('es-AR');

// Con centavos. El formatter de arriba los redondea, que está bien para un KPI
// pero no para un importe que hay que cotejar contra una factura.
const formatterMonedaExacta = new Intl.NumberFormat('es-AR', {
  style: 'currency',
  currency: 'ARS',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

/** Importe con símbolo y separadores de miles: 1250000 → "$ 1.250.000" */
export const formatMoney = (valor) => formatterMoneda.format(valor || 0);

/** Igual que formatMoney pero con centavos: 1250000.5 → "$ 1.250.000,50" */
export const formatMoneyExacto = (valor) => formatterMonedaExacta.format(valor || 0);

/** Número con separadores de miles: 1250 → "1.250" */
export const formatNumber = (valor) => formatterNumero.format(valor || 0);

/**
 * Importe abreviado, para las tarjetas de KPI donde no entra el número entero.
 * 1250000 → "$1,3 M" · 45000 → "$45,0 K"
 */
export const formatMoneyCorto = (valor) => {
  const n = valor || 0;
  const signo = n < 0 ? '-' : '';
  const abs = Math.abs(n);

  if (abs >= 1_000_000) return `${signo}$${(abs / 1_000_000).toFixed(1).replace('.', ',')} M`;
  if (abs >= 1_000)     return `${signo}$${(abs / 1_000).toFixed(1).replace('.', ',')} K`;
  return formatMoney(n);
};

/** Fecha ISO de SAP → "dd/mm/aaaa". Devuelve "—" si no hay fecha. */
export const formatFecha = (iso) => {
  if (!iso) return '—';
  const [anio, mes, dia] = iso.slice(0, 10).split('-');
  return `${dia}/${mes}/${anio}`;
};

/** "2026-03" → "mar 2026", para los ejes de los gráficos mensuales. */
export const formatMes = (yyyyMm) => {
  if (!yyyyMm) return '';
  const [anio, mes] = yyyyMm.split('-');
  const nombres = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
  return `${nombres[Number(mes) - 1] || mes} ${anio}`;
};
